import { utagLinkPDP } from 'features/tealium';
import { baseAPIRequest } from 'utilities/http';

const trackPDPEvents = utagLinkPDP();

const savePageViewRecord = (shortsku, typeId) => {

	const url = `/api/productdetail/savepageviewrecord/${shortsku}/${typeId}/`;
	const params = {
		method: 'POST'
	};
	return baseAPIRequest({ url, params });

};

function initPrintableLifeSizeImg () {

	const printableLifeSizeImg = document.querySelector('#printableLifeSizeImg');
	const printablePdfButton = document.querySelector('.printablePdfButton');
	const shortSku = printableLifeSizeImg.dataset.shortsku;
	const trackDownloadPdfFile = () => {

		trackPDPEvents({
			eventCategory: 'PDP',
			eventAction: 'Click-Download-PDF-File',
			eventLabel: shortSku
		});
		// when user clicks to download the pdf
		savePageViewRecord(shortSku, 2)
			.then((response) => {

				if (!response.IsSuccess) {

					console.error('savePageViewRecord api request requires a ShortSku querystring ');

				}

			})
			.catch((error) => {

				console.error('error', error);

			});

	};

	const printableLifeSizeImgModal = (e) => {

		e.preventDefault();

		$(document.body).lpModal({
			onInit: true,
			content: $('#printablePDFInfo'),
			width: 700,
			height: 425
		});

		trackPDPEvents({
			eventCategory: 'PDP',
			eventAction: 'Click-Printable-PDF',
			eventLabel: shortSku
		});
		// when user clicks to open the modal
		savePageViewRecord(shortSku, 1)
			.then((response) => {

				if (!response.IsSuccess) {

					console.error('savePageViewRecord api request requires a ShortSku querystring ');

				}

			})
			.catch((error) => {

				console.error('error', error);

			});

		printablePdfButton.removeEventListener('click', trackDownloadPdfFile);
		printablePdfButton.addEventListener('click', trackDownloadPdfFile);

	};

	printableLifeSizeImg.addEventListener('click', printableLifeSizeImgModal);

}

export default initPrintableLifeSizeImg;
